import React from "react";
import { Page } from "../activities/AppPage";
import { isLoading, Loading } from "../Loading";
import { CaregiverCertification } from "../messages";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import InformationCenterScreen from "./InformationCenterScreen";

interface Props {
  caregiver: AppCaregiver | Loading;
  onClickGoBack: () => void;
  onRequestNavigate: (page: Page) => void;
}

const InformationCenterActivity = (props: Props) => {
  if (isLoading(props.caregiver)) {
    return <></>;
  }

  const hha = CaregiverCertification.wrap("HHA");
  const pca = CaregiverCertification.wrap("PCA");
  const shouldShowMyVirtualId =
    props.caregiver.shouldShowVirtualIdCard &&
    (props.caregiver.certifications.includes(hha) || props.caregiver.certifications.includes(pca));
  const shouldShowMedflytHandbook = props.caregiver.isCaregiverOfMedFlyt;

  return (
    <InformationCenterScreen
      caregiver={props.caregiver}
      shouldShowMedflytHandbook={shouldShowMedflytHandbook}
      shouldShowMyVirtualId={shouldShowMyVirtualId}
      onClickGoBack={props.onClickGoBack}
      onRequestNavigate={props.onRequestNavigate}
    />
  );
};

export default InformationCenterActivity;
